import { render } from "./SaveProjectTeamsModal.vue?vue&type=template&id=bbdf93b2"
import script from "./SaveProjectTeamsModal.vue?vue&type=script&lang=js"
export * from "./SaveProjectTeamsModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__